export default [{
  path: '/home',
  name: 'home',
  component: () =>
    import('@/components/commonComponents/Home.vue'),
  redirect: '/home/workbench',
  children: [
    {
      path: 'workbench',
      name: 'workbench',
      component: () =>
        import('../views/workbench/workbench.vue')
    },
    {
      path: 'businessManagementIndex',
      name: 'businessManagementIndex',
      component: () =>
        import('../views/businessManagement/index.vue')
    },
    {
      path: '3dshoppingcategory',
      name: '3dshoppingcategory',
      component: () =>
        import('../views/3dshopping/category')
    },
    {
      path: '3dshoppinggoodMessage',
      name: '3dshoppinggoodMessage',
      component: () =>
        import('../views/3dshopping/goodMessage.vue')
    },
    {
      path: '3dshoppinggoodMessage/3dshoppinggoodMessagetentryGoods',
      name: '3dshoppinggoodMessagetentryGoods',
      component: () =>
        import('../views/3dshopping/components/entryGoods.vue')
    },
    {
      path: '3dbussinesspermissions',
      name: '3dbussinesspermissions',
      component: () =>
        import('../views/3dbussiness/permissions.vue')
    },
    {
      path: '3dbussinesspeopleGL',
      name: '3dbussinesspeopleGL',
      component: () =>
        import('../views/3dbussiness/peopleGL.vue')
    },
    {
      path: '3dbussinesspeopleGL/3dbussinessaddpeople',
      name: '3dbussinessaddpeople',
      component: () =>
        import('../views/3dbussiness/components/addpeople.vue')
    },
    {
      path: 'dingdanoverview',
      name: 'dingdanoverview',
      component: () =>
        import('../views/dingdan/overview.vue')
    },
    {
      path: 'dingdanindentList',
      name: 'dingdanindentList',
      component: () =>
        import('../views/dingdan/indentList.vue')
    },
    {
      path: 'dingdanindentList/dingdanlinteam',
      name: 'dingdanlinteam',
      component: () =>
        import('../views/dingdan/components/linteam.vue')
    },
    {
      path: 'databoardflowStatistics',
      name: 'databoardflowStatistics',
      component: () =>
        import('../views/databoard/flowStatistics.vue')
    },
    {
      path: 'databoardstaffStatistics',
      name: 'databoardstaffStatistics',
      component: () =>
        import('../views/databoard/staffStatistics.vue')
    },
    {
      path: 'databoardsalesStatistics',
      name: 'databoardsalesStatistics',
      component: () =>
        import('../views/databoard/salesStatistics.vue')
    },
    {
      path: 'databoardstaffStatistics/databoardstatisticsdetail',
      name: 'databoardstatisticsdetail',
      component: () =>
        import('../views/databoard/components/statisticsdetail.vue')
    },
    {
      path: 'chatChannel',
      name: 'chatChannel',
      component: () =>
        import('../views/weChatChannel/weChatChannel')
    },
    {
      path: 'accountindex',
      name: 'accountindex',
      component: () =>
        import('../views/account/index.vue')
    }
  ]
}
]